import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pasteInput", "preview", "fileInput", "csvSubmit", "csvForm"]

  parse() {
    const text = this.pasteInputTarget.value.trim()

    if (text.length === 0) {
      this.previewTarget.innerHTML = ""
      return
    }

    clearTimeout(this.parseTimeout)
    this.parseTimeout = setTimeout(() => {
      this.sendParseRequest(text)
    }, 300)
  }

  async sendParseRequest(text) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch("/contacts/parse_paste", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken
        },
        body: `text=${encodeURIComponent(text)}`
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        this.showParseError("Could not parse contacts. Please try a different format.")
      }
    } catch (error) {
      console.error("Parse error:", error)
      this.showParseError("Network error. Please check your connection and try again.")
    }
  }

  showParseError(message) {
    if (this.hasPreviewTarget) {
      this.previewTarget.innerHTML = `
        <div class="p-4 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
          <div class="flex items-center gap-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            ${message}
          </div>
        </div>
      `
    }
  }

  fileSelected() {
    const hasFile = this.fileInputTarget.files.length > 0
    this.csvSubmitTarget.disabled = !hasFile
  }

  toggleSkip(event) {
    const checkbox = event.target
    const row = checkbox.closest("tr")

    if (checkbox.checked) {
      row.classList.add("opacity-50")
    } else {
      row.classList.remove("opacity-50")
    }
  }
}
